import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import * as LaunchDarkly from 'launchdarkly-js-client-sdk';
import { AppConfig } from './app-config';

import { SessionService } from './session.service';

const helper = new JwtHelperService();

@Injectable()
export class LaunchDarklyService {
  public client: LaunchDarkly.LDClient;
  private user: LaunchDarkly.LDUser;

  constructor(
    protected _config: AppConfig,
    protected _sessionService: SessionService
  ) {
    const decodedToken = helper.decodeToken(this._sessionService.getAuthToken());

    this.user = {
      key: decodedToken && decodedToken.userId,
      email: '',
      name: ''
    };
    this.client = LaunchDarkly.initialize(this._config.getLaunchDarkleyKey(), this.user);
  }
}
